import React from 'react';
import { EditableText } from './inline/EditableText';

const VenueSection = ({ content, sectionId }) => {
  const title = content?.title || 'The 2027 Venue';
  const description = content?.description || 'The World Nuclear Congress takes place at the University of Tennessee, Knoxville, a nationally recognized leader in nuclear engineering education and research. Located near a dense concentration of nuclear companies and the historic Oak Ridge National Laboratory, Knoxville sits at the heart of America\'s nuclear innovation corridor. UT Knoxville\'s strength in nuclear engineering and related disciplines makes it an ideal venue for shaping the future of nuclear energy, security, and workforce development.';
  const scope = (path) => ({ type: 'homepage_section', sectionId, path });

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a 
              href="https://www.utk.edu" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block hover:opacity-80 transition-opacity"
            >
              <img
                src="/assets/images/utk-logo.png"
                alt="The University of Tennessee Knoxville - Department of Nuclear Engineering"
                className="w-40 md:w-48 lg:w-56 h-auto"
              />
            </a>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl font-bold text-[#00457f] mb-6" data-testid="venue-section-title">
              <EditableText as="span" scope={scope('title')} value={title} multiline={false}>{title}</EditableText>
            </h2>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              <EditableText as="span" scope={scope('description')} value={description}>{description}</EditableText>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenueSection;
